import React, { useState, useImperativeHandle } from 'react';
function MultiSelectRadio( { label, defaultValue, gridWidth, icon, options, name , onChange , visible } , ref ) {
    const containerClass = [
        'multiselect',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    const initialSelected = [];
    if ( defaultValue !== null && defaultValue !== '' ) {
        const values = defaultValue.split(',');
        for ( let i = 0; i < values.length; i++ ) {
            const val = values[i].trim();

            for ( let j = 0; j < options.length; j++ ) {
                if ( options[j].value === val ) {
                    initialSelected.push( options[j].value );
                    break;
                }
            }
        }
    }

    const [ selectedValues, setSelectedValues ] = useState( initialSelected );

    useImperativeHandle(ref, () => ({
        getValue: function () {
            return selectedValues.join(',');
        },
        setValue: function (valString) {
            const values = valString.split(',');
            const newSelected = [];
    
            for ( let i = 0; i < values.length; i++ ) {
                const val = values[i].trim();
    
                for ( let j = 0; j < options.length; j++ ) {
                    if (options[j].value === val) {
                        newSelected.push(options[j].value);
                        break;
                    }
                }
            }
    
            setSelectedValues(newSelected);
        }
    }));
    
    const toggleOption = function( value ) {
        const newSelected = selectedValues.includes(value)
        ? selectedValues.filter(v => v !== value)
        : [...selectedValues, value];

        setSelectedValues( newSelected );

        if (typeof onChange === 'function') {
            onChange( newSelected );
        }
    };

    return (
        <div className={containerClass}>
            {label != null && (
                <label className="multiselect-label">
                    {icon != null && (
                        <span
                            className="multiselect-icon"
                            dangerouslySetInnerHTML={{ __html: icon }}
                        />
                    )}
                    {label}
                </label>
            )}
    
            <div className="radio-options multi-select-radio-options">
            {options.map((option) => {
                const isSelected = selectedValues.includes( option.value );

                return (
                    <label
                        key={ name + '-' + option.id }
                        className={`radio-option ${isSelected ? 'selected' : ''}`}
                    >
                        <input
                            type="checkbox"
                            name={name}
                            value={option.value}
                            checked={isSelected}
                            onChange={() => toggleOption(option.value)}
                        />
                        { option.icon != null ? (
                            <span
                                className="radio-icon-only"
                                dangerouslySetInnerHTML={{ __html: option.icon }}
                                aria-label={option.value}
                            />
                        ) : (
                            <span className="radio-text">{option.value}</span>
                        )}
                    </label>
                );
            })}
            </div>
        </div>
    );
}

export default React.forwardRef( MultiSelectRadio );